import JustValidate from 'just-validate'
import $ from 'jquery'

window.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.form__service')
    const modal = document.querySelector('#form-sent-modal')
    if (!form) return

    const validation = new JustValidate('section.form .form__service', {
        errorFieldCssClass: 'form__input-error',
        errorLabelCssClass: 'form__error',
        focusInvalidField: true,
    })

    const ERRORS = {
        NAME: {
            REQUIRED: 'Nazwa jest wymagana',
        },
        EMAIL: {
            REQUIRED: 'Email jest wymagany',
            ERROR: 'Email jest niepoprawny',
        },
        TEL: {
            NUMBER: 'Niepoprawny nr tel',
        },
        MESSAGE: {
            REQUIRED: 'Treść wiadomości jest wymagana',
        },
        CHECKBOX: {
            REQUIRED: 'To pole jest wymagane',
        },
    }

    validation
        .addField('input[name=name]', [
            {
                rule: 'required',
                errorMessage: ERRORS.NAME.REQUIRED,
            },
        ])
        .addField('input[name=email]', [
            {
                rule: 'required',
                errorMessage: ERRORS.EMAIL.REQUIRED,
            },
            {
                rule: 'email',
                errorMessage: ERRORS.EMAIL.ERROR,
            },
        ])
        .addField('input[name=tel]', [
            {
                rule: 'number',
                errorMessage: ERRORS.TEL.NUMBER,
            },
        ])
        .addField('textarea[name=message]', [
            {
                rule: 'required',
                errorMessage: ERRORS.MESSAGE.REQUIRED,
            },
        ])
        .addField('input[type=checkbox]', [
            {
                rule: 'required',
                errorMessage: ERRORS.CHECKBOX.REQUIRED,
            },
        ])

    const openModal = () => {
        $(modal).show({
            duration: 300,
        })
    }

    const sendMessage = (e) => {
        e.preventDefault()
        if (!validation.isValid) return
        const submitBtn = document.querySelector('button[type=submit]')
        submitBtn.classList.add('btn-submit-loading')
        const data = new FormData(e.target)

        fetch(brzeski_transport_global?.site_url + '/wp-json/api/mail', {
            method: 'POST',
            body: data,
        })
            .then(function (res) {
                return res.json()
            })
            .then(function (json) {
                if (json.error) return
                modal && openModal()
                form.reset()
            })
            .catch((err) => {
                console.error(err)
            })
            .finally(() => {
                submitBtn.classList.remove('btn-submit-loading')
            })
    }
    form.addEventListener('submit', sendMessage)
})
